const adminAgentTools = {
  actions: {
    cancel: 'Cancel',
    create: 'Create',
    save: 'Save',
  },
  bindings: {
    actions: {
      add: 'Add Tools',
      clear: 'Clear all',
      clearGroup: 'Clear group',
      clearGroupLabel: 'Clear the currently displayed Tools in {{name}}',
      collapsePicker: 'Collapse Tool picker',
      confirmSelection: 'Confirm selection',
      confirmCurrent: 'Use latest configuration',
      manage: 'Manage Tools',
      save: 'Save Tool selection',
      selectCurrent: 'Select current catalog',
      selectCurrentResults: 'Select current results',
      selectGroup: 'Select all',
      selectGroupLabel: 'Select all available displayed Tools in {{name}}',
      viewDetails: 'Details',
    },
    empty: 'No Tools are available for this Agent.',
    exactBindingNotice:
      'Only the Tools selected now are saved. Selected Tools automatically adopt the latest definition for the same remote identity; newly added Tools are not enabled automatically.',
    exactBindingHelpLabel: 'About Tool access',
    feedback: {
      saved: 'Tool settings saved',
    },
    picker: {
      allSources: 'All sources',
      builtin: 'Builtin',
      connectionUnknown: 'Unnamed MCP service',
      empty: 'No matching Tools',
      groupSelection: '{{selected}} of {{total}} selected',
      groupToolCount: '{{count}} Tools',
      noSelection: 'No Tools selected',
      resultCount: '{{count}} results',
      searchLabel: 'Search Tools',
      searchPlaceholder: 'Search Tool, capability, or MCP service',
      sourceGroups: 'Tool source groups',
      title: 'Select Tools',
      toggleGroup: 'Expand or collapse {{name}}',
    },
    review: {
      confirmed: 'The latest configuration for this Tool is confirmed.',
      missing: 'This Tool was removed from the service. Deselect it before saving.',
      required:
        'This Tool’s parameters or configuration changed. View its details, then use the latest configuration.',
    },
    selectTool: 'Select {{name}}',
    selectionDescription:
      'Manage the Tools this Agent can use, grouped by MCP service or capability source.',
    selectionTitle: 'Tools',
    status: {
      builtin: 'Builtin',
      connectionDisabled: 'Service disabled',
      notReady: 'Temporarily unavailable',
      remoteReadOnlyHint: 'Remote hint: read-only',
      reviewRequired: 'Configuration updated',
      toolMissing: 'No longer discovered',
      unavailable: 'Unavailable',
    },
    summary: {
      reviewRequired: '{{count}} updated',
      selected: '{{count}} selected',
    },
    validation: {
      definition_missing: 'Remove Tools that are no longer in the current catalog before saving.',
      review_required: 'Confirm every Tool with an updated configuration before saving.',
      tool_name_conflict:
        'Selected Tools expose the same name “{{name}}”. Keep only one for this Agent, then save again.',
    },
    viewerNotice: 'Viewer access is read-only. An admin must change this Agent’s Tool settings.',
    workspaceLabel: 'Agent Tool settings',
  },
  connections: {
    actions: {
      confirmDelete: 'Delete Connection',
      create: 'Add MCP service',
      delete: 'Delete',
      edit: 'Edit',
      refresh: 'Refresh Tools',
      settings: 'Settings',
    },
    authentication: {
      anonymous: 'Anonymous',
      configured: 'Hub OAuth',
      external: {
        authorized: 'External OAuth · Authorized',
        authorizing: 'External OAuth · Authorizing',
        disconnected: 'External OAuth · Not authorized',
        error: 'External OAuth · Authorization failed',
        reconnect_required: 'External OAuth · Reauthorization required',
      },
      headersOnly: 'Request headers',
      incomplete: 'Authentication incomplete',
    },
    card: {
      lastRefresh: 'Last refresh',
      neverRefreshed: 'Not refreshed',
      actions: 'More actions for {{name}}',
      openDetails: 'View {{name}} details',
      toolCount: 'Tools',
      toolCountValue: '{{count}} Tools',
      updatedAt: 'Updated {{date}}',
    },
    deleteDialog: {
      description:
        'Delete “{{name}}”? A Connection still referenced by an Agent Binding cannot be deleted.',
      title: 'Delete MCP Connection',
    },
    details: {
      authentication: 'Credential',
      configRevision: 'Config revision',
      configuration: 'Advanced settings',
      diagnostics: 'Connection diagnostics',
      discoveryGeneration: 'Discovery generation',
      endpointPolicyRevision: 'Endpoint policy revision',
      errorCode: 'Latest error code',
      headerCount: '{{count}} configured',
      lastChecked: 'Last checked',
      lastHealthy: 'Last healthy',
      lastRefresh: 'Last refresh',
      none: 'None',
      notAvailable: 'Not available',
      notConfigured: 'Not configured',
      protocolVersion: 'Protocol version',
      resource: 'Resource URI',
      responseBudget: 'Response budget (discovery / execution)',
      requestHeaders: 'Request headers',
      server: 'Server',
      snapshotId: 'Snapshot ID',
      snapshotRevision: 'Snapshot revision',
      title: 'MCP / {{name}}',
      toolListTitle: '{{count}} Tools',
      tools: 'Tools',
      toolSetHash: 'Tool set hash',
    },
    empty: {
      description: 'Add an MCP service to get started.',
      title: 'No MCP services yet',
    },
    feedback: {
      created: 'MCP Connection created',
      deleted: 'MCP Connection deleted',
      noChanges: 'No Connection settings changed',
      oauthAuthorizationStarted: 'Opening the OAuth authorization page',
      oauthAuthorizationTimedOut: 'OAuth authorization timed out. Start authorization again.',
      oauthAuthorizedAndRefreshed: 'OAuth authorized and the Tool list was refreshed.',
      oauthAuthorizedRefreshFailed:
        'OAuth is authorized, but the Tool list could not be refreshed. Try again manually.',
      oauthDisconnected: 'External OAuth disconnected',
      oauthWindowClosed: 'The OAuth window was closed before authorization completed.',
      oauthReturn: {
        authorized: 'External OAuth is authorized. You can refresh the Tool list.',
        authorizing: 'External OAuth authorization is still in progress.',
        disconnected: 'External OAuth authorization did not complete.',
        error: 'External OAuth authorization failed. Try again.',
        reconnect_required: 'External OAuth requires authorization again.',
      },
      refreshed: 'Discovery refreshed: {{added}} added, {{changed}} changed, {{removed}} removed',
      updated: 'MCP Connection updated',
    },
    form: {
      authentication: {
        client: 'OAuth client',
        currentClient: 'Current OAuth client',
        currentClientBadge: 'Current',
        currentResource: 'Current OAuth Resource',
        description:
          'OAuth and request headers can be used together. Choose the OAuth method here.',
        external: {
          automaticDescription:
            'Uses MCP CIMD/DCR to obtain a client automatically when the service supports dynamic registration.',
          authorize: 'Authorize',
          callbackUri: 'Callback URI',
          callbackUriCopy: 'Copy',
          callbackUriCopied: 'Callback URI copied.',
          callbackUriCopyFailed: 'Could not copy the Callback URI.',
          clientId: 'Client ID',
          clientSecret: 'Client Secret',
          clientSecretConfigured: 'Configured; leave blank to keep',
          clientSecretHelp:
            'Enter this only when the provider issued a Secret. Hub discovers the token authentication method and Authorization Server automatically.',
          clientSecretOptional: 'Optional; enter the secret issued by the provider',
          confirmDisconnect: 'Disconnect',
          confirmReauthorize: 'Reauthorize',
          disconnect: 'Disconnect',
          disconnectBeforeSwitch:
            'Disconnect the current authorization before switching OAuth methods.',
          disconnectDescription:
            'After disconnecting, this MCP service cannot be used until it is authorized again.',
          disconnectTitle: 'Disconnect External OAuth?',
          reauthorize: 'Reauthorize',
          reauthorizeDescription:
            'The current authorization will be disconnected before the service authorization page opens again.',
          reauthorizeTitle: 'Reauthorize External OAuth?',
          preRegisteredDescription: 'Uses a Client issued by the remote service for authorization.',
          registrationMode: 'Client registration method',
          registrationModes: {
            automatic: 'Automatic (CIMD / DCR)',
            pre_registered: 'Pre-registered client',
          },
          status: {
            authorized: 'Authorized',
            authorizing: 'Authorizing',
            disconnected: 'Not authorized',
            error: 'Authorization failed',
            reconnect_required: 'Reauthorization required',
          },
          statusLabel: 'External OAuth status',
        },
        headersRemainAvailable:
          'OAuth is disabled. API keys and other credentials can still be configured under Request headers.',
        keepCurrent: 'Keep current authentication',
        loadClientsFailed: 'OAuth clients could not be loaded. Try again.',
        manageClients: 'Manage clients',
        modes: {
          external: 'External OAuth',
          hub: 'Hub OAuth',
          none: 'No OAuth',
        },
        noClients: 'No MCP OAuth client is available. Create one in Identity first.',
        selectClient: 'Select an OAuth client',
        title: 'Authentication',
      },
      createTitle: 'Add MCP service',
      editTitle: 'Edit / {{name}}',
      fields: {
        clearCredential: 'Remove the saved credential reference',
        credentialReference: 'Credential reference',
        displayName: 'Name',
        enabled: 'Service enabled',
        endpointUri: 'Service endpoint URL',
        oauthScopes: 'OAuth scopes',
        resourceUri: 'Resource URI',
      },
      hints: {
        credential:
          'Use a supported opaque reference such as hub-oidc-client:<record UUID>. The saved value is never returned to the browser.',
        credentialSaved:
          'A credential reference is saved. Leave this field empty to preserve it, or enter a new reference to rotate it.',
        credentialWillClear: 'The saved credential reference will be removed.',
        enabled:
          'Disabling the Connection keeps its review history but makes its Tools unavailable.',
        enabledShort: 'When disabled, Agents cannot use this service.',
        endpoint:
          'Standard URL query parameters are supported and remain visible as part of the endpoint. Use OAuth or request headers for tokens and secrets.',
        oauthScopes:
          'One real scope name per line. Scope names come from Identity/resource configuration; Hub does not generate them from Tool names.',
        resource: 'Optional absolute resource URI used by the managed OAuth execution flow.',
        targetLocked:
          'Endpoint and resource are fixed after the first successful discovery. Create a new Connection to change the remote identity.',
        targetLockedShort: 'This service is connected, so its endpoint can no longer be changed.',
      },
      headers: {
        add: 'Add request header',
        configuredPlaceholder: 'Configured; leave blank to keep',
        description: 'Additional HTTP request headers sent to the MCP service, including API keys.',
        empty: 'No request headers configured.',
        keepConfiguredHint:
          'A value is securely stored. Leave this blank to preserve it, or enter a value to replace it.',
        name: 'Header name',
        remove: 'Remove request header {{name}}',
        title: 'Request headers',
        value: 'Header value',
      },
      loadingName: 'loading',
      placeholders: {
        displayName: 'Name your MCP service',
      },
      tabs: {
        authentication: 'Authentication',
        headers: 'Request headers',
        label: 'MCP connection settings',
      },
      validation: {
        authorizationConflict: 'OAuth owns the Authorization header while OAuth is enabled.',
        displayNameRequired: 'Enter a display name.',
        clientRequired: 'Select an OAuth client.',
        endpointRequired: 'Enter an endpoint URI.',
        externalClientIdRequired: 'Enter the Client ID issued by the remote service.',
        headerNameDuplicate: 'Header names must be unique, ignoring letter case.',
        headerNameInvalid: 'Enter a valid HTTP token header name.',
        headerNameRequired: 'Enter a header name.',
        headerValueInvalid: 'Header values cannot contain line breaks.',
        headerValueRequired: 'A new request header requires a value.',
      },
    },
    health: {
      blocked: 'Blocked',
      healthy: 'Healthy',
      invalid_response: 'Invalid response',
      unknown: 'Not checked',
      unreachable: 'Unreachable',
    },
    page: {
      description: 'Connect and manage MCP services.',
      title: 'MCP',
    },
    refreshDialog: {
      confirm: 'Refresh Tool list',
      description:
        'Existing bindings adopt the latest Tool definitions automatically. Newly added Tools stay disabled, and removed Tools become unavailable.',
      title: 'Refresh the Tool list?',
    },
    refreshNotice: {
      credentialsChanged:
        'Authentication changed, so the previous Tool snapshot is no longer current.',
      later: 'Later',
      now: 'Refresh Tool list now',
    },
    search: {
      clear: 'Clear search',
      empty: 'No MCP services match this search.',
      label: 'Search MCP services',
      placeholder: 'Search by name or endpoint',
    },
    status: {
      disabled: 'Disabled',
      enabled: 'Enabled',
    },
    transport: {
      label: 'Connection method',
      streamableHttp: 'Streamable HTTP',
    },
    tools: {
      annotations: 'Remote annotations',
      closeDetails: 'Close Tool details',
      definitionId: 'Definition ID',
      definitionRevision: 'Definition revision',
      empty: 'No current Tool definitions. Run discovery after the Connection is configured.',
      execution: 'Execution metadata',
      executionPolicyRevision: 'Execution policy revision',
      inputSchema: 'Input schema',
      inputParameters: 'Input parameters',
      inputValue: 'Input value',
      nestedFieldCount: '{{count}} fields',
      noOutputFields: '{{type}} is declared without named fields.',
      noParameters: 'No parameters',
      noStructuredOutput: 'No structured output is declared.',
      openDetails: 'View {{name}} details',
      outputSchema: 'Output schema',
      outputParameters: 'Output parameters',
      outputRequired: 'Always present',
      readOnlyHintNotice:
        'readOnlyHint is remote review metadata only. It neither grants access nor blocks execution; real authorization comes from the current Binding, credential, resource, scopes, and execution policy.',
      readOnlyHintHelpLabel: 'About remote readOnlyHint',
      remoteReadOnlyHint: 'Remote hint: read-only',
      required: 'Required',
      returnValue: 'Return value',
      schemaLimitNotice:
        'See technical details for deeper fields or fields beyond the display limit.',
      sourceReference: 'Source reference',
      technicalDetails: 'Technical details',
    },
    viewerNotice: 'Viewer access is read-only. An admin must change or refresh Connections.',
    workspaceLabel: 'MCP Connection workspace',
  },
  errors: {
    codes: {
      agentNotFound: 'The selected Self-Agent App no longer exists.',
      bindingConflict: 'The Agent’s Tool settings changed. Reload and try again.',
      connectionConflict: 'A Connection with this display name already exists.',
      connectionInUse: 'This Connection is still used by an Agent Binding.',
      connectionNotFound: 'The MCP Connection no longer exists.',
      connectionRevisionConflict: 'The Connection changed. Reload and try again.',
      definitionChanged: 'A selected Tool configuration changed. Reload and confirm it again.',
      discoveryAuthenticationFailed: 'The remote MCP Server rejected discovery authentication.',
      discoveryConnectionFailed: 'Hub could not connect to the MCP Server.',
      discoveryEndpointRejected: 'The endpoint, redirect, DNS, or network target was rejected.',
      discoveryInvalidCatalog:
        'The MCP Server returned an incomplete or inconsistent Tool catalog.',
      discoveryInvalidResponse: 'The MCP Server returned an invalid protocol response.',
      discoveryResponseTooLarge: 'The discovery response exceeded this Connection’s byte budget.',
      discoveryTimeout: 'MCP discovery timed out.',
      discoveryToolsNotSupported: 'The MCP Server does not support Tool discovery.',
      externalOAuthConfigInvalid:
        'The pre-registered OAuth client configuration is incomplete or invalid.',
      invalidAgentType: 'The selected App is not a Self-Agent App.',
      invalidBindings: 'The selected Tool set is invalid.',
      toolNameConflict: 'Selected Tools expose the same name. Keep only one for this Agent.',
      oauthAuthorizationUnavailable:
        'OAuth authorization could not start. Check the endpoint, network, and remote authentication settings.',
      oauthAuthorizationDenied: 'You canceled authorization or the provider rejected the request.',
      oauthAuthorizationFailed:
        'OAuth authorization failed. Check the remote authentication settings and try again.',
      oauthClientAuthMethodUnavailable:
        'The remote service does not support a token authentication method compatible with this client.',
      oauthCredentialUnavailable: 'The OAuth credential is unavailable. Authorize again.',
      oauthFlowExpired: 'The OAuth authorization record expired. Start authorization again.',
      oauthIssuerMismatch:
        'The configured issuer does not match the Authorization Server discovered from the MCP service.',
      oauthIssuerUnavailable: 'The MCP OAuth issuer could not be verified safely.',
      oauthNotConfigured: 'External OAuth is not configured for this MCP service.',
      oauthResolverUnavailable: 'OAuth discovery is currently unavailable.',
      targetImmutable: 'Create a new Connection to change a target that was already discovered.',
      targetInvalid: 'The endpoint or resource URI is invalid or unsafe.',
      unknownTool: 'A selected Builtin Tool no longer exists.',
      writeForbidden: 'Your role has read-only access to Agent Tools.',
    },
    loadBindings: 'The Agent’s Tool settings could not be loaded. Try again.',
    loadBindingsTitle: 'Unable to load Tool settings',
    loadConnection: 'The MCP Connection could not be loaded. Try again.',
    loadConnectionTitle: 'Unable to load MCP Connection',
    loadConnections: 'MCP Connections could not be loaded. Try again.',
    loadConnectionsTitle: 'Unable to load MCP Connections',
    loadTargets: 'Self-Agent Apps could not be loaded. Try again.',
    loadTargetsTitle: 'Unable to load Agent choices',
    loadTools: 'Current Tool definitions could not be loaded. Try again.',
    loadToolsTitle: 'Unable to load current Tools',
    oauthPopupBlocked: 'The browser blocked the OAuth window. Allow popups and try again.',
    operationFailed: 'The operation failed. Check the current configuration and try again.',
  },
  page: {
    description: 'Manage the MCP services and Tools available to Agents.',
    title: 'Agent Tools',
  },
  tabs: {
    bindings: 'Agent bindings',
    connections: 'MCP Connections',
  },
}

export default adminAgentTools
